/* istanbul ignore file */
import { useFieldHelper } from 'framework/ui/field';
import { useBudgetUrl } from 'domain/shared/budget';
import { useBudgetService } from 'domain/shared/budget';
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';

interface CopyBudgetButtonProps {
  value?: StringOrNumber;
  nameSource?: string;
  permissionToCheck?: string;
  source: string;
  isVisible?: boolean | ((data: any) => boolean);
}

const CopyBudgetForNextYearButton = ({
  permissionToCheck,
  nameSource,
  isVisible = true,
  ...props
}: CopyBudgetButtonProps) => {
  const { getValue } = useFieldHelper(props);
  const { getValue: getName } = useFieldHelper({ source: nameSource });
  const { getListUrl } = useBudgetUrl();
  const { copyForNextYear } = useBudgetService();

  const copyForNextYearAction = async () => {
    return copyForNextYear(getValue());
  };

  return (
    <ButtonWithConfirmation
      afterSubmit={{
        redirectUrl: getListUrl(),
        successMessage: `${getName()} was copied for the next year`,
        errorMessage: `${getName()} can not be copied for the next year`,
      }}
      modalConfirmButtonText="Copy"
      submitMethod={copyForNextYearAction}
      permissionToCheck={permissionToCheck}
      displayMessage="Do you really want to copy this budget?"
      title="Copy budget for the next year"
      color="secondary"
      variant="outlined"
      isVisible={isVisible}
    >
      Copy
    </ButtonWithConfirmation>
  );
};

export default CopyBudgetForNextYearButton;
